import { Navigate, Route, Routes } from 'react-router-dom';
import { DiorHistoryDashboard } from './dior-components/DiorHistoryDashboard';
import { DiorDataDashboard } from './dior-components/DiorDataDashboard';

export const DiorDashboard = () => {
  return (
    <Routes>
      <Route index element={<DiorHistoryDashboard />} />
      <Route path='data' element={<DiorDataDashboard />} />
      <Route path='*' element={<Navigate to='' replace />} />
    </Routes>
  );
};